import { Component } from 'react';
import GraphGenerator from './graph-generator';
import './heatmap/heatmap.css';
import './handpath-graph.css';
import '../../../fonts/web_fonts/timocco_icons/style.css';
import Heatmap from './heatmap/heatmap';
import { Col, Row } from 'reactstrap';

class HandpathGraph extends Component {
  componentDidMount() {
    this.graphGenerator = new GraphGenerator();
    // eslint-disable-next-line
    this.heatmapData = this.graphGenerator.drawFullPath(
      this.refs.handpath_graph,
      this.props.handpath,
      this.props.game_id,
      this.props.game_type
    );

    this.heatmap = new Heatmap('heatmap_' + this.props.result_id, 22, 15, ['blue', 'red']);
    this.heatmap.update(this.heatmapData);
    this.generatedHitmap = true;
  }

  render() {
    return (
      <div className="mp-0 container-fluid angle_chart_graph_container">
        <Row className="mp-0">
          <Col className="mp-0">
            <b style={{ textDecoration: 'underline' }}>Controller Path</b>
            <div className="mp-0 handpath-graph-container">
              {false && <i className="icon-siluhette"></i>}
              <canvas width="177" height="120" className="handpath_graph" ref="handpath_graph" />
            </div>
          </Col>
          <Col className="mp-0">
            <b style={{ textDecoration: 'underline' }}>Heat Map</b>
            <div id={'heatmap_' + this.props.result_id} className="heatmap_container" style={{ width: 177 }}>
              {false && <i className="icon-siluhette heatmap-siluhette"></i>}
            </div>
          </Col>
          <div className="handpath_small_text">Screen Coverage: {this.props.screen_percentage}%</div>
        </Row>
      </div>
    );
  }
}

export default HandpathGraph;
